import { ENV_VALUES } from '@/config/env';
import { Role } from '@informme/shared/schemas/rbac/Rbac';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import authStore, { rolePermissions } from '../store/AuthStore';

Vue.use(VueRouter);
const routes: RouteConfig[] = [
  {
    path: '/',
    name: '',
    redirect: { path: '/editor' },
    children: [
      {
        path: '/institution',
        alias: 'praxis', // kept for compatibility
        name: 'institution',
        component: () => import('../error/PageNotFound.vue'),
      },
      {
        path: '/done',
        name: 'done',
        component: () => import('../form/Done.vue'),
      },
    ],
  },
  {
    path: '/editor',
    name: 'editor',
    meta: { requiresAuth: true },
    component: () => import('../editor/Editor.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../login/Login.vue'),
  },
  {
    path: '*',
    redirect: '/error',
    component: () => import('../error/PageNotFound.vue'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../error/PageNotFound.vue'),
  },
];

const router = new VueRouter({
  // mode: 'history', // TODO: use history router with lib for express
  base: ENV_VALUES.BASE_URL,
  routes,
  scrollBehavior() {
    // on Route change, always scroll back to top
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, _, next) => {
  const routePath = to.path as string; // e.g. /admin/dashboard

  if (!to.meta?.requiresAuth) return next();

  // Check if token is expired
  if (authStore.isTokenExpired && authStore.userLoggedIn) {
    authStore.handleTokenExpiration();
    return next({ path: '/login', query: { to: to.fullPath } });
  }

  // routePath should include some of the permitted paths for the role
  const role = authStore.user?.roles?.find((r: Role) =>
    rolePermissions[r]?.some((path) => routePath.includes(path)),
  );

  if (!role) {
    if (authStore.userLoggedIn) authStore.setErrorMessage(403);
    return next({ path: '/login', query: { to: to.fullPath } });
  }

  return next();
});

export default router;
